var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBraceletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.697 23.3262C7.48832 22.241 1.00049 17.5161 1.00049 12.1595C1.00049 5.99343 8.16304 0.996338 17.0003 0.996338C25.8375 0.996338 33.0001 5.99343 33.0001 12.1595C33.0001 17.5161 26.5167 22.241 19.3036 23.3262",
    stroke: "#9C9C9C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9981 20.252C8.73446 19.4668 3.09717 16.0435 3.09717 12.1631C3.09717 7.69641 9.32127 4.07422 17.0003 4.07422C24.6793 4.07422 30.9034 7.69641 30.9034 12.1631C30.9034 16.0435 25.2705 19.4668 19.0025 20.252",
    stroke: "#9C9C9C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9698 20.2833C19.2115 20.8695 19.3522 21.5709 19.3522 22.3247C19.3522 22.6667 19.3236 22.9947 19.2686 23.3087C18.9961 24.893 18.084 26.0585 17.0005 26.0585C15.917 26.0585 15.0028 24.893 14.7324 23.3087C14.6775 22.9947 14.6489 22.6667 14.6489 22.3247C14.6489 21.5709 14.7896 20.8695 15.0313 20.2833C15.4511 19.2643 16.1764 18.5908 17.0005 18.5908C17.8247 18.5908 18.55 19.2643 18.9698 20.2833Z",
    stroke: "#9C9C9C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.2478V22.4013",
    stroke: "#9C9C9C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraceletIcon);
export default __webpack_public_path__ + "static/media/bracelet-icon.6a88c3f70444d426a1a9acfb78a89a32.svg";
export { ForwardRef as ReactComponent };